import React, {Component, PropTypes} from 'react'
import AppNavBar from './AppNavBar'
import AppToolbar from './AppToolbar'
import Helmet from 'react-helmet'
import config from '../../config'

class AuthLayout extends Component {
    static propTypes = {
        children: PropTypes.node
    }

    render() {
        const {children} = this.props

        return (
            <div>
                <Helmet titleTemplate={ `${config.whiteMark.titlePrefix} | %s` } />
                <AppNavBar />
                <AppToolbar />
                {children}
            </div>
        )
    }
}

export default AuthLayout


// WEBPACK FOOTER //
// ./lib/app/components/AuthLayout.js